const PaymentMethodSelector = ({ selectedMethod, onMethodChange }) => {
    const paymentMethods = [
        {
            value: 'cash',
            label: 'CASH',
            icon: '💵',
            gradient: 'from-emerald-500 to-teal-600'
        },
        {
            value: 'bank_transfer',
            label: 'BANK TRANSFER',
            icon: '🏦',
            gradient: 'from-blue-500 to-indigo-600'
        },
        {
            value: 'qris',
            label: 'QRIS',
            icon: '📱',
            gradient: 'from-purple-500 to-pink-600'
        }
    ];

    return (
        <div className="max-w-2xl mx-auto bg-gradient-to-br from-gray-50 to-white rounded-3xl">
            <div className="space-y-6">
                <div className="text-center">
                    <h3 className="text-2xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-2">
                        Metode Pembayaran
                    </h3>
                    <p className="text-gray-500 text-sm">Pilih metode pembayaran yang kamu gunakan</p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                    {paymentMethods.map((method) => {
                        const isSelected = selectedMethod === method.value;
                        return (
                            <label
                                key={method.value}
                                className={`relative group cursor-pointer transition-all duration-300 transform hover:scale-105 ${isSelected ? 'scale-105' : ''}`}
                            >
                                <input
                                    type="radio"
                                    name="payment_method"
                                    value={method.value}
                                    checked={isSelected}
                                    onChange={onMethodChange}
                                    className="hidden"
                                />

                                <div className={`
                                    relative overflow-hidden rounded-2xl p-6 border-2 transition-all duration-300
                                    ${isSelected
                                        ? `bg-gradient-to-br ${method.gradient} text-white border-transparent shadow-2xl`
                                        : 'bg-white hover:bg-gray-50 text-gray-700 border-gray-200 hover:border-gray-300 shadow-md hover:shadow-lg'
                                    }
                                `}>
                                    {/* Animated background for selected state */}
                                    {isSelected && (
                                        <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent animate-pulse"></div>
                                    )}

                                    {/* Icon */}
                                    <div className="text-center mb-3">
                                        <span className={`text-3xl ${isSelected ? 'animate-bounce' : 'group-hover:animate-pulse'}`}>
                                            {method.icon}
                                        </span>
                                    </div>

                                    {/* Label */}
                                    <div className="text-center relative z-10">
                                        <span className={`font-bold text-sm tracking-wide ${isSelected ? 'text-white' : 'text-gray-700'}`}>
                                            {method.label}
                                        </span>
                                    </div>

                                    {/* Selection indicator */}
                                    {isSelected && (
                                        <div className="absolute top-2 right-2 w-6 h-6 bg-white/30 rounded-full flex items-center justify-center">
                                            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    )}

                                    {/* Hover effect ring */}
                                    <div className={`absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${!isSelected ? 'ring-2 ring-gray-300/50' : ''}`}></div>
                                </div>
                            </label>
                        );
                    })}
                </div>

                {/* Selected method display */}
                {selectedMethod && (
                    <div className="text-center p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl border border-blue-100">
                        <p className="text-sm text-gray-600 mb-1">Metode pembayaran terpilih:</p>
                        <p className="font-semibold text-indigo-600">
                            {paymentMethods.find(m => m.value === selectedMethod)?.label}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentMethodSelector; 